import {EventBus} from "../../../../common/ts/events/EventBus";
import eventHandlers from "./eventHandlers";
import {GOOGLE_COOKIES_ENABLED_LOCAL_STORAGE_KEY} from "../cmpAdsManager/constants";

function init(device: string) {
    eventHandlers.init(EventBus.getInstance(), device);
}

export function hasConsentForGoogleCookies() {
    return localStorage.getItem(GOOGLE_COOKIES_ENABLED_LOCAL_STORAGE_KEY);
}

export function hasGoogleOneTapAlreadyBeenPrompted() {
    return document.cookie.indexOf('_showGoogleOneTap') !== -1;
}

export default {
    init,
};
